import { render, staticRenderFns } from "./MassiveActions.vue?vue&type=template&id=74fb22d6&"
import script from "./MassiveActions.vue?vue&type=script&lang=js&"
export * from "./MassiveActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74fb22d6')) {
      api.createRecord('74fb22d6', component.options)
    } else {
      api.reload('74fb22d6', component.options)
    }
    module.hot.accept("./MassiveActions.vue?vue&type=template&id=74fb22d6&", function () {
      api.rerender('74fb22d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/massiveProcess/MassiveActions.vue"
export default component.exports